import { Injectable, inject, signal, computed } from '@angular/core';
import {MenuItem} from 'primeng/api';
import { MenuAdminService } from './menu/menu-admin.service';
import { MenuUserService } from './menu/menu-user.service';

export type UserRole = 'Administrador' | 'Propietario/Inquilino' | 'Proveedores' | 'Portero/Vigilante/Mantenimiento';

@Injectable({ providedIn: 'root' })
export class MenuBuilderService {
  private menuAdminService = inject(MenuAdminService);
  private menuUserService = inject(MenuUserService);

  // Signal para el rol actual del usuario
  private currentRole = signal<UserRole>('Administrador');

  // Getter para el rol actual
  getCurrentRole(): UserRole {
    return this.currentRole();
  }

  // Setter para cambiar el rol
  setCurrentRole(role: UserRole): void {
    this.currentRole.set(role);
  }

  // Computed signal para el menú que se actualiza reactivamente cuando cambia el rol
  menuItems = computed<MenuItem[]>(() => {
    const role = this.currentRole();

    // Decidir qué menú mostrar basado en el rol
    switch (role) {
      case 'Administrador':
        return this.menuAdminService.buildMenu();

      case 'Propietario/Inquilino':
      case 'Proveedores':
      case 'Portero/Vigilante/Mantenimiento':
        return this.menuUserService.buildMenu();

      default:
        return this.menuAdminService.buildMenu();
    }
  });

  buildMenu(): MenuItem[] {
    return this.menuItems();
  }
}


